import { useState } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function Market() {
  const [scrolled, setScrolled] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<'vip' | 'spawner'>('vip');
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [selectedServer, setSelectedServer] = useState<'skyblock' | 'boxpvp' | null>(null);

  useState(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  });

  const handlePurchaseClick = (item: any) => {
    setSelectedItem(item);
    setSelectedServer(null);
    setShowPurchaseModal(true);
  };

  const vipPackages = [
    {
      name: 'VIP',
      price: '50 TL',
      image: 'https://public.readdy.ai/ai/img_res/141d1d67c3e505f63d8dd719000d246b.jpg',
      features: [
        'Özel VIP Prefix',
        '/fly komutu',
        '5 Home noktası',
        'VIP Spawn bölgesi',
        'Günlük ödüller',
        'Chat renkleri'
      ]
    },
    {
      name: 'Mega VIP',
      price: '100 TL',
      image: 'https://readdy.ai/api/search-image?query=minecraft%20mega%20vip%20rank%20badge%20epic%20diamond%20crown%20with%20blue%20crystal%20effects%20ultra%20premium%20membership%20card%20game%20interface%20clean%20simple%20background%20professional%20luxury%20design&width=400&height=300&seq=vip-002&orientation=landscape',
      features: [
        'Tüm VIP özellikleri',
        '/god komutu',
        '10 Home noktası',
        'Mega VIP Spawn',
        'Özel kit',
        'Pet sistemi',
        'Nickname değiştirme'
      ]
    },
    {
      name: 'Ultra VIP',
      price: '200 TL',
      image: 'https://readdy.ai/api/search-image?query=minecraft%20ultra%20vip%20rank%20badge%20legendary%20netherite%20crown%20with%20blue%20lightning%20effects%20supreme%20premium%20membership%20card%20game%20interface%20clean%20simple%20background%20professional%20elite%20design&width=400&height=300&seq=vip-003&orientation=landscape',
      features: [
        'Tüm Mega VIP özellikleri',
        '/heal komutu',
        '20 Home noktası',
        'Ultra VIP Spawn',
        'Özel silahlar',
        'Özel zırhlar',
        'Sınırsız /back',
        'Özel partiküller'
      ]
    },
    {
      name: 'Windo5DJ VIP',
      price: '350 TL',
      image: 'https://readdy.ai/api/search-image?query=minecraft%20windo5dj%20custom%20vip%20rank%20badge%20ultimate%20enchanted%20crown%20with%20blue%20magical%20aura%20effects%20exclusive%20premium%20membership%20card%20game%20interface%20clean%20simple%20background%20professional%20legendary%20design&width=400&height=300&seq=vip-004&orientation=landscape',
      features: [
        'Tüm Ultra VIP özellikleri',
        '/tp komutu',
        'Sınırsız home',
        'Özel Windo5DJ Spawn',
        'Efsanevi silahlar',
        'Efsanevi zırhlar',
        'Özel komutlar',
        'Özel efektler',
        'Öncelikli destek'
      ]
    },
    {
      name: 'Sponsor',
      price: '500 TL',
      image: 'https://readdy.ai/api/search-image?query=minecraft%20sponsor%20rank%20badge%20mythical%20glowing%20crown%20with%20blue%20cosmic%20effects%20ultimate%20premium%20membership%20card%20game%20interface%20clean%20simple%20background%20professional%20godlike%20design&width=400&height=300&seq=vip-005&orientation=landscape',
      features: [
        'Tüm Windo5DJ VIP özellikleri',
        'Tüm komutlar',
        'Sınırsız her şey',
        'Sponsor Spawn',
        'Mitolojik itemler',
        'Özel yetenekler',
        'Sunucu yönetimi',
        'Özel Discord rolü',
        '7/24 öncelikli destek',
        'İsim değiştirme'
      ]
    }
  ];

  const spawners = [
    {
      name: 'İnek Spawner',
      price: '25 TL',
      image: 'https://readdy.ai/api/search-image?query=minecraft%20cow%20spawner%20cage%20block%20with%20rotating%20cow%20inside%20blue%20magical%20particles%20farm%20animal%20spawner%20game%20item%20clean%20simple%20background%20detailed%203d%20render&width=400&height=300&seq=spawner-001&orientation=landscape',
      description: 'Sürekli inek üretir. Et ve deri kaynağı.'
    },
    {
      name: 'Domuz Spawner',
      price: '25 TL',
      image: 'https://readdy.ai/api/search-image?query=minecraft%20pig%20spawner%20cage%20block%20with%20rotating%20pig%20inside%20blue%20magical%20particles%20farm%20animal%20spawner%20game%20item%20clean%20simple%20background%20detailed%203d%20render&width=400&height=300&seq=spawner-002&orientation=landscape',
      description: 'Sürekli domuz üretir. Et kaynağı.'
    },
    {
      name: 'Koyun Spawner',
      price: '30 TL',
      image: 'https://readdy.ai/api/search-image?query=minecraft%20sheep%20spawner%20cage%20block%20with%20rotating%20sheep%20inside%20blue%20magical%20particles%20farm%20animal%20spawner%20game%20item%20clean%20simple%20background%20detailed%203d%20render&width=400&height=300&seq=spawner-003&orientation=landscape',
      description: 'Sürekli koyun üretir. Yün ve et kaynağı.'
    },
    {
      name: 'Örümcek Spawner',
      price: '50 TL',
      image: 'https://readdy.ai/api/search-image?query=minecraft%20spider%20spawner%20cage%20block%20with%20rotating%20spider%20inside%20blue%20magical%20particles%20hostile%20mob%20spawner%20game%20item%20clean%20simple%20background%20detailed%203d%20render&width=400&height=300&seq=spawner-004&orientation=landscape',
      description: 'Sürekli örümcek üretir. İp ve göz kaynağı.'
    },
    {
      name: 'Zombi Spawner',
      price: '75 TL',
      image: 'https://readdy.ai/api/search-image?query=minecraft%20zombie%20spawner%20cage%20block%20with%20rotating%20zombie%20inside%20blue%20magical%20particles%20hostile%20mob%20spawner%20game%20item%20clean%20simple%20background%20detailed%203d%20render&width=400&height=300&seq=spawner-005&orientation=landscape',
      description: 'Sürekli zombi üretir. XP ve çürük et kaynağı.'
    },
    {
      name: 'İskelet Spawner',
      price: '75 TL',
      image: 'https://readdy.ai/api/search-image?query=minecraft%20skeleton%20spawner%20cage%20block%20with%20rotating%20skeleton%20inside%20blue%20magical%20particles%20hostile%20mob%20spawner%20game%20item%20clean%20simple%20background%20detailed%203d%20render&width=400&height=300&seq=spawner-006&orientation=landscape',
      description: 'Sürekli iskelet üretir. XP, kemik ve ok kaynağı.'
    },
    {
      name: 'Creeper Spawner',
      price: '100 TL',
      image: 'https://readdy.ai/api/search-image?query=minecraft%20creeper%20spawner%20cage%20block%20with%20rotating%20creeper%20inside%20blue%20magical%20particles%20explosive%20mob%20spawner%20game%20item%20clean%20simple%20background%20detailed%203d%20render&width=400&height=300&seq=spawner-007&orientation=landscape',
      description: 'Sürekli creeper üretir. XP ve barut kaynağı.'
    },
    {
      name: 'Enderman Spawner',
      price: '150 TL',
      image: 'https://readdy.ai/api/search-image?query=minecraft%20enderman%20spawner%20cage%20block%20with%20rotating%20enderman%20inside%20blue%20purple%20magical%20particles%20rare%20mob%20spawner%20game%20item%20clean%20simple%20background%20detailed%203d%20render&width=400&height=300&seq=spawner-008&orientation=landscape',
      description: 'Sürekli enderman üretir. XP ve ender pearl kaynağı.'
    },
    {
      name: 'Demir Golem Spawner',
      price: '200 TL',
      image: 'https://readdy.ai/api/search-image?query=minecraft%20iron%20golem%20spawner%20cage%20block%20with%20rotating%20iron%20golem%20inside%20blue%20magical%20particles%20legendary%20mob%20spawner%20game%20item%20clean%20simple%20background%20detailed%203d%20render&width=400&height=300&seq=spawner-009&orientation=landscape',
      description: 'Sürekli demir golem üretir. Demir ve gül kaynağı.'
    }
  ];

  return (
    <div className="min-h-screen bg-[#0a0e1a]">
      <Navbar scrolled={scrolled} />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 px-4">
        <div className="absolute inset-0 bg-gradient-to-b from-[#3b82f6]/10 to-transparent"></div>
        <div className="max-w-7xl mx-auto relative z-10">
          <div className="text-center mb-12">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              <i className="ri-shopping-bag-3-line mr-4"></i>
              Market
            </h1>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto">
              VIP paketleri ve spawner'ları satın alarak sunucuda avantaj elde et!
            </p>
          </div>

          {/* Category Tabs */}
          <div className="flex justify-center mb-12">
            <div className="bg-[#1a1f35] rounded-full p-1 inline-flex">
              <button
                onClick={() => setSelectedCategory('vip')}
                className={`px-8 py-3 rounded-full font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  selectedCategory === 'vip'
                    ? 'bg-gradient-to-r from-[#3b82f6] to-[#2563eb] text-white shadow-lg'
                    : 'text-gray-400 hover:text-white'
                }`}
              >
                <i className="ri-vip-crown-line mr-2"></i>
                VIP Paketleri
              </button>
              <button
                onClick={() => setSelectedCategory('spawner')}
                className={`px-8 py-3 rounded-full font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  selectedCategory === 'spawner'
                    ? 'bg-gradient-to-r from-[#3b82f6] to-[#2563eb] text-white shadow-lg'
                    : 'text-gray-400 hover:text-white'
                }`}
              >
                <i className="ri-box-3-line mr-2"></i>
                Spawner'lar
              </button>
            </div>
          </div>

          {/* VIP Packages */}
          {selectedCategory === 'vip' && (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {vipPackages.map((vip, index) => (
                <div
                  key={index}
                  className="group bg-gradient-to-br from-[#1a1f35] to-[#0f1420] rounded-2xl overflow-hidden border border-[#3b82f6]/20 hover:border-[#3b82f6]/60 transition-all duration-300 hover:transform hover:scale-105 hover:shadow-2xl hover:shadow-[#3b82f6]/30"
                >
                  <div className="relative w-full h-48 overflow-hidden">
                    <img
                      src={vip.image}
                      alt={vip.name}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0f1420] to-transparent"></div>
                  </div>
                  
                  <div className="p-6">
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="text-2xl font-bold text-white">{vip.name}</h3>
                      <span className="text-2xl font-bold text-[#3b82f6]">{vip.price}</span>
                    </div>
                    
                    <ul className="space-y-2 mb-6">
                      {vip.features.map((feature, idx) => (
                        <li key={idx} className="flex items-start text-gray-400 text-sm">
                          <i className="ri-check-line text-[#3b82f6] mr-2 mt-0.5 flex-shrink-0"></i>
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                    
                    <button 
                      onClick={() => handlePurchaseClick(vip)}
                      className="w-full bg-gradient-to-r from-[#3b82f6] to-[#2563eb] text-white py-3 rounded-lg font-semibold hover:from-[#2563eb] hover:to-[#1d4ed8] transition-all duration-200 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                    >
                      <i className="ri-shopping-cart-line mr-2"></i>
                      Satın Al
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Spawners */}
          {selectedCategory === 'spawner' && (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {spawners.map((spawner, index) => (
                <div
                  key={index}
                  className="group bg-gradient-to-br from-[#1a1f35] to-[#0f1420] rounded-2xl overflow-hidden border border-[#3b82f6]/20 hover:border-[#3b82f6]/60 transition-all duration-300 hover:transform hover:scale-105 hover:shadow-2xl hover:shadow-[#3b82f6]/30"
                >
                  <div className="relative w-full h-48 overflow-hidden">
                    <img
                      src={spawner.image}
                      alt={spawner.name}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0f1420] to-transparent"></div>
                  </div>
                  
                  <div className="p-6">
                    <div className="flex items-center justify-between mb-3">
                      <h3 className="text-xl font-bold text-white">{spawner.name}</h3>
                      <span className="text-xl font-bold text-[#3b82f6]">{spawner.price}</span>
                    </div>
                    
                    <p className="text-gray-400 text-sm mb-6">{spawner.description}</p>
                    
                    <button 
                      onClick={() => handlePurchaseClick(spawner)}
                      className="w-full bg-gradient-to-r from-[#3b82f6] to-[#2563eb] text-white py-3 rounded-lg font-semibold hover:from-[#2563eb] hover:to-[#1d4ed8] transition-all duration-200 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                    >
                      <i className="ri-shopping-cart-line mr-2"></i>
                      Satın Al
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Info Box */}
          <div className="mt-16 bg-gradient-to-r from-[#3b82f6]/10 to-[#2563eb]/10 rounded-2xl p-8 border border-[#3b82f6]/20">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-[#3b82f6]/20 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-information-line text-2xl text-[#3b82f6]"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-white mb-2">Satın Alma Bilgileri</h3>
                <p className="text-gray-400 text-sm leading-relaxed">
                  Satın aldığınız VIP paketleri ve spawner'lar otomatik olarak oyun içi hesabınıza tanımlanır. 
                  Herhangi bir sorun yaşarsanız Discord sunucumuzdan destek alabilirsiniz. 
                  Tüm ödemeler güvenli ödeme sistemleri üzerinden gerçekleştirilir.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Purchase Modal */}
      {showPurchaseModal && selectedItem && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4">
          <div className="bg-gradient-to-br from-[#1a1f35] to-[#0f1420] rounded-2xl max-w-md w-full border border-[#3b82f6]/30 shadow-2xl">
            <div className="p-6 border-b border-[#3b82f6]/20">
              <div className="flex items-center justify-between">
                <h3 className="text-2xl font-bold text-white">Satın Al</h3>
                <button
                  onClick={() => setShowPurchaseModal(false)}
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>
            </div>

            <div className="p-6 space-y-6">
              {/* Selected Item */}
              <div className="bg-[#0a0e1a] rounded-lg p-4">
                <div className="flex items-center justify-between">
                  <span className="text-white font-semibold">{selectedItem.name}</span>
                  <span className="text-[#3b82f6] font-bold">{selectedItem.price}</span>
                </div>
              </div>

              {/* Server Selection */}
              <div>
                <label className="block text-white font-semibold mb-3">
                  <i className="ri-server-line mr-2"></i>
                  Sunucu Seç
                </label>
                <div className="grid grid-cols-2 gap-3">
                  <button
                    onClick={() => setSelectedServer('skyblock')}
                    className={`p-4 rounded-lg border-2 transition-all duration-200 cursor-pointer ${
                      selectedServer === 'skyblock'
                        ? 'border-[#3b82f6] bg-[#3b82f6]/20'
                        : 'border-[#3b82f6]/20 hover:border-[#3b82f6]/40'
                    }`}
                  >
                    <i className="ri-treasure-map-line text-2xl text-[#3b82f6] mb-2 block"></i>
                    <span className="text-white font-semibold text-sm">Skyblock</span>
                  </button>
                  <button
                    onClick={() => setSelectedServer('boxpvp')}
                    className={`p-4 rounded-lg border-2 transition-all duration-200 cursor-pointer ${
                      selectedServer === 'boxpvp'
                        ? 'border-[#3b82f6] bg-[#3b82f6]/20'
                        : 'border-[#3b82f6]/20 hover:border-[#3b82f6]/40'
                    }`}
                  >
                    <i className="ri-sword-line text-2xl text-[#3b82f6] mb-2 block"></i>
                    <span className="text-white font-semibold text-sm">BoxPvP</span>
                  </button>
                </div>
              </div>

              {/* Payment Methods */}
              <div>
                <label className="block text-white font-semibold mb-3">
                  <i className="ri-bank-card-line mr-2"></i>
                  Ödeme Yöntemi
                </label>
                <div className="space-y-3">
                  <div className="relative">
                    <button className="w-full p-4 rounded-lg border-2 border-[#3b82f6]/20 hover:border-[#3b82f6]/40 transition-all duration-200 text-left cursor-pointer">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                          <i className="ri-bank-card-2-line text-xl text-[#3b82f6]"></i>
                          <span className="text-white">Kredi Kartı</span>
                        </div>
                        <span className="bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full" style={{ fontFamily: 'Minecraft, monospace' }}>
                          YAKINDA
                        </span>
                      </div>
                    </button>
                  </div>
                  <div className="relative">
                    <button className="w-full p-4 rounded-lg border-2 border-[#3b82f6]/20 hover:border-[#3b82f6]/40 transition-all duration-200 text-left cursor-pointer">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                          <i className="ri-paypal-line text-xl text-[#3b82f6]"></i>
                          <span className="text-white">PayPal</span>
                        </div>
                        <span className="bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full" style={{ fontFamily: 'Minecraft, monospace' }}>
                          YAKINDA
                        </span>
                      </div>
                    </button>
                  </div>
                  <div className="relative">
                    <button className="w-full p-4 rounded-lg border-2 border-[#3b82f6]/20 hover:border-[#3b82f6]/40 transition-all duration-200 text-left cursor-pointer">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                          <i className="ri-money-dollar-circle-line text-xl text-[#3b82f6]"></i>
                          <span className="text-white">Havale / EFT</span>
                        </div>
                        <span className="bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full" style={{ fontFamily: 'Minecraft, monospace' }}>
                          YAKINDA
                        </span>
                      </div>
                    </button>
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex gap-3 pt-4">
                <button
                  onClick={() => setShowPurchaseModal(false)}
                  className="flex-1 px-6 py-3 rounded-lg border-2 border-[#3b82f6]/30 text-white font-semibold hover:bg-[#3b82f6]/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  İptal
                </button>
                <button
                  disabled={!selectedServer}
                  className={`flex-1 px-6 py-3 rounded-lg font-semibold transition-all duration-200 whitespace-nowrap ${
                    selectedServer
                      ? 'bg-gradient-to-r from-[#3b82f6] to-[#2563eb] text-white hover:from-[#2563eb] hover:to-[#1d4ed8] cursor-pointer'
                      : 'bg-gray-600 text-gray-400 cursor-not-allowed'
                  }`}
                >
                  Devam Et
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
